import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const TextAreaCustom = styled.textarea`
  font-size: 0.8rem;
  line-height: 1rem;
  border-radius: 0.625rem;
  border: none;
  background-color: ${Colors.Color23};
  color: ${Colors.Color7} !important;

  align-self: center;
  padding: 0.9375rem 0.875rem;
  width: 10rem;
  height: 7rem;
  max-width: 100%;
  // box-shadow: 0px 0px 10px rgb(0 0 0 / 5%);
  border: 0;
  // border: 0.1em solid ${Colors.bgColor1};
  border-radius: 0.625rem;

  ::-webkit-scrollbar {
    width: 0.5rem;
  }

  ::-webkit-scrollbar-track {
    :hover {
      width: 0.75rem;
      cursor: pointer;
    }
  }

  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 0.1rem solid slategrey;
    border-radius: 0.5rem;
  }

  &:read-only {
    background-color: ${Colors.Color12};
    border: 0.1rem solid ${Colors.Color12};
  }

  :disabled {
    background-color: ${Colors.Color12};
    border: 0.1rem solid ${Colors.Color12};
  }

  :focus,
  :hover {
    // background-color: ${Colors.bgColor3};
    // border: 0.1rem solid ${Colors.bgColor3};
  }
`;
